<template>
  <v-row class="text-right bottom-navigation-edit py-4 px-2">
    <v-col align-self="end">
      <v-btn
        width="120"
        class="mr-2 font-weight-regular letter-spacing-normal text-capitalize"
        depressed
        @click="onCancel"
        text>{{ $t('common.cancelBtn') }}
      </v-btn>
      <v-btn
        v-if="currentStep > 1"
        width="120"
        class="mr-2 font-weight-regular letter-spacing-normal text-capitalize"
        depressed
        @click="$emit('prev')"
        text>{{ $t('common.backBtn') }}
      </v-btn>
      <v-btn
        v-if="currentStep < totalSteps"
        id="btn-blue-disabled"
        width="120"
        class="primary font-weight-normal letter-spacing-normal text-capitalize"
        depressed
        color="primary"
        :disabled="nextDisabled || loading"
        :loading="loading"
        @click="$emit('next')">{{ $t('common.nextBtn') }}
      </v-btn>
      <v-btn
        v-if="currentStep === totalSteps"
        id="btn-blue-disabled"
        width="120"
        class="primary font-weight-normal letter-spacing-normal text-capitalize"
        depressed
        color="primary"
        :disabled="disabled || loading"
        :loading="loading"
        @click="onSave"
      >
        {{ type === 'reset' ? 'Reset' : 'Save' }}
      </v-btn>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'FormFooter',
  props: {
    changed: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'create' // Or 'edit'
    },
    // New props for stepper control
    currentStep: {
      type: Number,
      required: true
    },
    totalSteps: {
      type: Number,
      required: true
    },
    nextDisabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['cancel', 'submit', 'prev', 'next', 'save'],
  methods: {
    onSave() {
      this.$emit('save');
    },
    onCancel() {
      this.$emit('cancel');
    },
    emitNext() {
      // debug log to ensure click reaches the component
      // eslint-disable-next-line no-console
      this.$emit('next');
    }
  }
};
</script>
<style scoped>
.bottom-navigation-edit {
  position: absolute;
  bottom: 0 !important;
  left: 0;
  right: 0;
  margin: 0;
  border-top: 1px solid var(--v-divider-base, rgba(0, 0, 0, 0.12));
  z-index: 10;
  background-color: var(--v-general_bckgr-base);
}
</style>